<template>
  <div id="app" class="wrapper">
    <loading :isShow="showOrNot" @gogame="entergame" />
    <pageKV :carsubtype="cartype" @gomymusic="audioPlay" @gokoubo="kouboPlay" @gostopmusic="clearSubMusic"/>
    <musicplayer :isShow="showOrNot" @gomusic="mymusic"/>
    <rotate/>

    <audio :src="d001URL" id="d001" preload="preload"></audio>
    <audio :src="d002URL" id="d002" preload="preload"></audio>
    <audio :src="d003URL" id="d003" preload="preload"></audio>
    <audio :src="d004URL" id="d004" preload="preload"></audio>
    <audio :src="d005URL" id="d005" preload="preload"></audio>
    <audio :src="d006URL" id="d006" preload="preload"></audio>
    <audio :src="d007URL" id="d007" preload="preload"></audio>
    <audio :src="d008URL" id="d008" preload="preload"></audio>

    <audio :src="shuilongtouURL" id="shuilongtou" preload="preload"></audio>
    <audio :src="shuayaURL" id="shuaya" preload="preload"></audio>
    <audio :src="ditieURL" id="ditie" preload="preload"></audio>
    <audio :src="daziURL" id="dazi" preload="preload"></audio>
    <audio :src="chiURL" id="chi" preload="preload"></audio>
    <audio :src="messageURL" id="message" preload="preload"></audio>
    <audio :src="msgURL" id="msg" preload="preload"></audio>
    <audio :src="yanhuaURL" id="yanhua" preload="preload"></audio>
    <audio :src="jianpan2URL" id="jianpan2" preload="preload"></audio>
  </div>
</template>

<script>
import loading from './components/loading/index.vue'
import pageKV from './components/pageKV/index.vue'
import musicplayer from './components/musicplayer/index.vue'
import rotate from './components/rotate/index.vue'

export default {
  name: 'app',
  components: {
    loading,
    pageKV,
    musicplayer,
    rotate,
  },
  data(){
    return{
      showOrNot: {
        isLDShow: true,
        isKVShow: false,
        isPOShow: false,
        isPTShow: false,
        isPRShow: false
      },
      cartype:0,
      myMuiscState:true,
      d001URL: 'https://www.jiandoukeji.com/h5/2018/jdcs/music/001.mp3', //口播
      d002URL: 'https://www.jiandoukeji.com/h5/2018/jdcs/music/002.mp3', //口播
      d003URL: 'https://www.jiandoukeji.com/h5/2018/jdcs/music/003.mp3', //口播
      d004URL: 'https://www.jiandoukeji.com/h5/2018/jdcs/music/004.mp3', //口播
      d005URL: 'https://www.jiandoukeji.com/h5/2018/jdcs/music/005.mp3', //口播
      d006URL: 'https://www.jiandoukeji.com/h5/2018/jdcs/music/006.mp3', //口播
      d007URL: 'https://www.jiandoukeji.com/h5/2018/jdcs/music/007.mp3', //口播
      d008URL: 'https://www.jiandoukeji.com/h5/2018/jdcs/music/008.mp3', //口播
      shuilongtouURL: 'https://www.jiandoukeji.com/h5/2018/jdcs/music/shuilongtougai2.mp3', //水龙头
      shuayaURL: 'https://www.jiandoukeji.com/h5/2018/jdcs/music/shuaya.mp3', //刷牙
      ditieURL: 'https://www.jiandoukeji.com/h5/2018/jdcs/music/ditie.mp3', //地铁
      daziURL: 'https://www.jiandoukeji.com/h5/2018/jdcs/music/dazi.mp3', //打字
      chiURL: 'https://www.jiandoukeji.com/h5/2018/jdcs/music/chigai2.mp3', //加班吃
      messageURL: 'https://www.jiandoukeji.com/h5/2018/jdcs/music/message.mp3', //新消息
      msgURL: 'https://www.jiandoukeji.com/h5/2018/jdcs/music/msg.mp3', //展示消息
      yanhuaURL: 'https://www.jiandoukeji.com/h5/2018/jdcs/music/yanhua.mp3', //烟花
      jianpan2URL: 'https://www.jiandoukeji.com/h5/2018/jdcs/music/wandazi.mp3', //在家键盘
    }
  },
  mounted(){
    this.ininYuyin()
  },
  methods:{
    entergame(){
      this.cartype=1
    },
    mymusic(data){
      this.myMuiscState=data.musicstate

      if(!this.myMuiscState){
        //关闭所有音乐
        
      }
    },
    audioPlay (data) {
      if(this.myMuiscState){
        //清除其他辅助音乐
        this.clearSubMusic()

        let musicname=data.name

        let audio = document.getElementById(musicname)
        audio.volume = 1;
        audio.play()
        document.addEventListener('WeixinJSBridgeReady', function () {
          audio.play()
        }, false)
      }
    },
    kouboPlay (data) {
      if(this.myMuiscState){
        //清除其他辅助音乐
        //this.clearSubMusic()
        let musicname=data.name

        let audio = document.getElementById('d'+musicname)
        audio.play()
        document.addEventListener('WeixinJSBridgeReady', function () {
          audio.play()
        }, false)
      }
    },
    clearSubMusic(){
      this.audioPause('shuilongtou')
      this.audioPause('shuaya')
      this.audioPause('ditie')
      this.audioPause('dazi')
      this.audioPause('chi')
      this.audioPause('message')
      this.audioPause('msg')
      this.audioPause('yanhua')
      this.audioPause('jianpan2')
    },
    audioPause (name) {
      let audio = document.getElementById(name)
      audio.pause()
      document.addEventListener('WeixinJSBridgeReady', function () {
        audio.pause()
      }, false)
    },
    oneininYuyin(name){
      //语音初始化
      var audio = document.getElementById(name);
      audio.volume = 0;
      audio.play();
      document.addEventListener("WeixinJSBridgeReady", function () {
        audio.play();
      }, false);

      setTimeout(function(){
        audio.pause();
        document.addEventListener("WeixinJSBridgeReady", function () {
          audio.pause();
        }, false);
      },200)
    },
    ininYuyin(){
      this.oneininYuyin('d001')
      this.oneininYuyin('d002')
      this.oneininYuyin('d003')
      this.oneininYuyin('d004')
      this.oneininYuyin('d005')
      this.oneininYuyin('d006')
      this.oneininYuyin('d007')
      this.oneininYuyin('d008')

      this.oneininYuyin('shuilongtou')
      this.oneininYuyin('shuaya')
      this.oneininYuyin('ditie')
      this.oneininYuyin('dazi')
      this.oneininYuyin('chi')
      this.oneininYuyin('message')
      this.oneininYuyin('msg')
      this.oneininYuyin('yanhua')
      this.oneininYuyin('jianpan2')
    }
  }
}
</script>

<style lang="less" >
@import './assets/reset.less';
#app {
  position: fixed;
}
.swiper{
  position: relative;
  overflow: hidden;
}

#mypageKV{
  height: 100%;
}

#mypageKV canvas{
  width: 100%;
}
</style>
